import { useTranslation } from 'react-i18next';

interface Props {
  hide?: boolean;
  isLoading: boolean;
  isFetchEnabled?: boolean;
  onEnable?: () => void;
}

export default function LoadingHeader({ isLoading, hide = false, isFetchEnabled = true, onEnable }: Props) {
  const { t } = useTranslation();

  if (hide) return null;

  if (isFetchEnabled || isLoading) {
    return (
      <div className='z-40 flex justify-center animate-pulse text-body1 animate-duration-1000'>
        <span className='pr-2 text-sm font-semibold'>{t('conversation.loading')}</span>
        <span className='loading loading-dots loading-xs' />
      </div>
    );
  }

  if (isFetchEnabled) {
    return (
      <div className='z-40 flex justify-center text-body1'>
        <span className='pr-2 text-sm font-semibold'>{t('conversation.load-more-messages')}</span>
      </div>
    );
  }

  return (
    <div className='py-2 z-40 flex justify-center'>
      <button
        className='btn btn-sm bg-slate-500/70 text-white'
        onClick={onEnable}>
        {t('conversation.load-more-messages')}
      </button>
    </div>
  );
}
